<template>
    <v-menu location="start" :close-on-content-click="true">
        <template #activator="{ props: menuProps }">
            <v-btn icon variant="text" v-bind="menuProps" data-id="travelCardMenuBtn" class="rounded-lg">
                <v-icon class="font-weight-bold v-icon--size-x-large" color="success">mdi-dots-vertical</v-icon>
            </v-btn>
        </template>

        <v-list border="primary opacity-100 md" class="rounded-lg bg-bg-primary mr-3" width="150">
            <travel-card-menu-item
                :name="t('travelCard.editName')"
                :icon="edit"
                data-id="editTravelCardButton"
                @click="$emit('update:update-is-visible', true)"
            />
            <travel-card-menu-item
                :name="t('travelCard.block')"
                color="error"
                :icon="greyLock"
                data-id="blockTravelCardButton"
                @click="$emit('update:block-is-visible', true)"
            />
            <travel-card-menu-item
                :name="t('travelCard.remove')"
                color="error"
                :icon="bin"
                data-id="deleteTravelCardButton"
                @click="$emit('click:delete-is-visible')"
            />
        </v-list>
    </v-menu>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { ITravelCardMenu } from '../../types';
import TravelCardMenuItem from './components/TravelCardMenuItem.vue';
import edit from '@/assets/edit.svg';
import greyLock from '@/assets/grey_lock.svg';
import bin from '@/assets/bin.svg';

const { t } = useI18n();

defineProps<ITravelCardMenu>();
defineEmits(['update:update-is-visible', 'update:block-is-visible', 'click:delete-is-visible']);
</script>
